import styled from 'styled-components';

export const StyledParameterLineDiv = styled.div`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledParameterTitleLineDiv = styled.div`
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;

  *:not(:first-child) {
    margin-left: 5px;
  }

  i {
    color: ${(p) => p.theme.palette.red.shade40};
    font-style: normal;
  }
`;
